import axios from 'axios'
import jsonp from 'jsonp'

let COM_BASE_URL = 'https://ws-test.maserati.com'
let WTL_BASE_URL = 'https://wtl-test.maserati.com'

if (process.env.SERVICE_STAGE === 'production') {
  COM_BASE_URL = 'https://ws-test.maserati.com'
  WTL_BASE_URL = 'https://wtl-test.maserati.com'
}

const GENERIC_LOV_API = `${WTL_BASE_URL}/wtl/jsonGenericLov.jsp`
const SAVE_USER_API = `${COM_BASE_URL}/comserv/public/subscribe/saveSITjson`
const GET_GDPR_API = `${COM_BASE_URL}/comserv/public/privacy/gdpr?country=$1&lang=$2&form_type=guest`

export const getCountries = () => {
  return new Promise((resolve) => {
    // eslint-disable-next-line
    jsonp(`${GENERIC_LOV_API}?lovType=COUNTRY`, null, (err, data) => {
      resolve(data)
    })
  })
}

export const getLanguages = () => {
  return new Promise((resolve) => {
    // eslint-disable-next-line
    jsonp(`${GENERIC_LOV_API}?lovType=LANGUAGE`, null, (err, data) => {
      resolve(data)
    })
  })
}

export const getGdpr = ({ country, lang }) => {
  return new Promise((resolve) => {
    const api = GET_GDPR_API.replace('$1', country).replace('$2', lang)
    // eslint-disable-next-line
    jsonp(api, null, (err, data) => {
      resolve(data)
    })
  })
}

export const saveUser = (data) => {
  return axios.post(SAVE_USER_API, null, { data })
}

export const getUserCountry = () => {
  return axios.get(process.env.GEO_API_ENDPOINT)
    .then(({ data }) => {
      return data.country
    })
    .catch(console.log)
}
